import { render, staticRenderFns } from "./RegistrationStep3.vue?vue&type=template&id=21c1cab0&scoped=true"
import script from "./RegistrationStep3.vue?vue&type=script&lang=js"
export * from "./RegistrationStep3.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep3.vue?vue&type=style&index=0&id=21c1cab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1cab0",
  null
  
)

export default component.exports